/* eslint-disable no-unused-vars */
import Cookie from 'js-cookie';
import get from 'lodash/get';
import React, { useContext, useEffect, useState } from 'react';
import PriceIcon from '../../assets/images/price-icon.png';
import { AppContext } from '../../context/AppContext';
import ApiHelper from '../../data/ApiHelper';
import Cart from '../../data/Cart';
import UsernameWallet from '../common/UsernameWallet';
import PayPalButton from '../PayPalButton/PayPalButton';
import './CheckOut.css';

export default function CheckOut() {
    const { state, dispatch } = useContext(AppContext);
    const [error, setError] = useState('');
    const [isBusy, setIsBusy] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [showBagModal, setShowBagModal] = useState(false);
    const [bagInfo, setBagInfo] = useState(null);
    const [isCheckingBag, setIsCheckingBag] = useState(false);
    const { user, cart } = state;
    const cartId = get(cart, 'id', '');
    const coupon = get(cart, 'coupon', '');
    const products = get(cart, 'products', []);
    const packages = get(cart, 'packages', []);
    const [selectedField, setSelectedField] = useState(
        products.length > 0 ? 'products' : 'packages'
    );
    const [characterNames, setCharacterNames] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const subtotal = get(cart, 'totalCartPrice', 0);
    const [total, setTotal] = useState(() => {
        if (coupon && selectedField !== 'packages') {
            return Number(cart.totalPriceAfterCoupon);
        }
        return subtotal;
    });
    useEffect(() => {
        setSelectedField(products.length > 0 ? 'products' : 'packages');
    }, [products]);
    // const subtotal = get(cart, 'totalCartPrice', 0);
    useEffect(() => {
        setTotal((coupon && selectedField !== 'packages') ? Number(cart.totalPriceAfterCoupon) : subtotal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subtotal, selectedField]);

    useEffect(() => {
        const onSuccess = (response) => {
            const data = get(response, 'data.0', []);

            setCharacterNames(data);
        };

        const onError = () => { };

        const token = Cookie.get('token');
        const userParams = {
            AccountId: +localStorage.getItem('userGameDbId'),
        };

        ApiHelper.games.getUserCharacters(userParams, token).then(onSuccess).catch(onError);
    }, []);

    const checkBagCapacity = async () => {
        if (!selectedOption) return { ok: true };
        setIsCheckingBag(true);
        try {
            const token = Cookie.get('token');
            const response = await ApiHelper.games.checkBagCapacity({
                CharacterName: selectedOption,
            }, token);
            const data = response.data;
            const freeSlots = data.freeSlots || 0;

            // Calculate total items needed
            let totalItemsNeeded = 0;
            for (const p of products) {
                const qty = p.totalProductQuantity || 1;
                totalItemsNeeded += qty;
            }

            if (freeSlots < totalItemsNeeded) {
                setBagInfo({
                    freeSlots,
                    totalSlots: data.totalSlots || 66,
                    usedSlots: data.usedSlots || 0,
                    needed: totalItemsNeeded,
                });
                setShowBagModal(true);
                setIsCheckingBag(false);
                return { ok: false };
            }
            setIsCheckingBag(false);
            return { ok: true };
        } catch (err) {
            setIsCheckingBag(false);
            // If the check fails, let the server-side validation handle it
            return { ok: true };
        }
    };

    const handleRecheck = async () => {
        setIsCheckingBag(true);
        try {
            const token = Cookie.get('token');
            const response = await ApiHelper.games.checkBagCapacity({
                CharacterName: selectedOption,
            }, token);
            const data = response.data;
            const freeSlots = data.freeSlots || 0;

            let totalItemsNeeded = 0;
            for (const p of products) {
                const qty = p.totalProductQuantity || 1;
                totalItemsNeeded += qty;
            }

            if (freeSlots >= totalItemsNeeded) {
                setShowBagModal(false);
                setBagInfo(null);
            } else {
                setBagInfo({
                    freeSlots,
                    totalSlots: data.totalSlots || 66,
                    usedSlots: data.usedSlots || 0,
                    needed: totalItemsNeeded,
                });
            }
        } catch (err) {
            // keep modal open
        }
        setIsCheckingBag(false);
    };

    const onCheckout = async () => {
        if (isBusy || cart[selectedField].length <= 0 || !isChecked) return;
        const effectiveTotal = (coupon && selectedField !== 'packages') ? Number(cart.totalPriceAfterCoupon) : cart.totalCartPrice;
        if (user.coin < effectiveTotal) {
            setError(
                'You do not have enough coin to place order. Please buy coins from the Item Mall.'
            );
            return;
        }
        if (selectedField === 'products' && selectedOption === '') {
            alert('Please Choose Character To Assign Products');
            return;
        }

        // Check bag capacity before placing order
        if (selectedField === 'products') {
            const bagCheck = await checkBagCapacity();
            if (!bagCheck.ok) return;
        }

        setIsBusy(true);
        const token = Cookie.get('token');
        const reports = '';

        const data = {
            CharacterName: selectedField === 'products' ? selectedOption : '',
            OrderDetails: cart,
            Coupon: coupon,
            user_id: user.id,
            PaymentType: 'Coins',
        };

        const onSuccessOrder = (response) => {
            const updatedCart = new Cart(cartId);
            const updatedCoin =
                user.coin * 1 -
                (cart.totalPriceAfterCoupon ? cart.totalPriceAfterCoupon : cart.totalCartPrice);
            const updateData = {
                coin: updatedCoin,
            };

            const onSuccessUserUpdate = (responseUserUpdate) => {
                const updatedUser = get(responseUserUpdate, 'data', null);
                dispatch({ type: 'UPDATE_USER', user: updatedUser });
            };

            const onErrorUserUpdate = () => { };

            const onSuccessCartUpdate = (responseCart) => {
                const cartData = get(response, 'data', {});
                const cartDetails = get(cartData, 'cartDetails', []);
                dispatch({ type: 'UPDATE_CART', updatedCart });
                setSelectedOption('');
            };

            const onErrorCartUpdate = () => { };

            ApiHelper.carts
                .updateCart(cartId, { cartDetails: JSON.stringify(updatedCart) }, token)
                .then(onSuccessCartUpdate)
                .catch(onErrorCartUpdate);
            ApiHelper.user
                .update(updateData, user.id, token)
                .then(onSuccessUserUpdate)
                .catch(onErrorUserUpdate);
        };

        const onErrorOrder = (err) => {
            // Catch server-side bag capacity rejection
            const message = get(err, 'response.data.message', '');
            if (message && message.includes('Item Mall bag')) {
                setError(message);
            }
        };

        const onFinish = () => {
            setIsBusy(false);
        };

        ApiHelper.orders
            .createOrder(data, token)
            .then(onSuccessOrder)
            .catch(onErrorOrder)
            .finally(onFinish);
    };

    const ErrorMessage = error ? <p style={{ marginTop: 50, color: '#00fcff' }}>{error}</p> : <></>;

    const CartProductsItems = () => {
        if (cart[selectedField].length <= 0) return <></>;
        const items = cart[selectedField].map((item) => (
            <div className="cart-Block-bottom-bt flex-s-c">
                <div className="cart-subtotal">
                    {item.name} x {item.totalProductQuantity}
                </div>
                <div className="cart-total">
                    {selectedField === 'packages'
                        ? `$${Number(item.totalProductPrice).toFixed(2)}`
                        : `${item.totalProductPrice}`}
                </div>
                {/* <div className="cart-Table-close" /> */}
            </div>
        ));
        return items;
    };

    const BagFullModal = () => {
        if (!showBagModal || !bagInfo) return null;
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0, 0, 0, 0.75)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                        border: '2px solid #e94560',
                        borderRadius: '12px',
                        padding: '30px 40px',
                        maxWidth: '480px',
                        width: '90%',
                        textAlign: 'center',
                        boxShadow: '0 8px 32px rgba(233, 69, 96, 0.3)',
                    }}
                >
                    <div style={{ fontSize: '40px', marginBottom: '12px' }}>⚠️</div>
                    <h3
                        style={{
                            color: '#e94560',
                            margin: '0 0 16px 0',
                            fontSize: '20px',
                            fontWeight: 'bold',
                        }}
                    >
                        Item Mall Bag is Full
                    </h3>
                    <p
                        style={{
                            color: '#ccc',
                            fontSize: '14px',
                            lineHeight: '1.6',
                            margin: '0 0 8px 0',
                        }}
                    >
                        Your Item Mall bag does not have enough free slots to receive the purchased items.
                    </p>
                    <p
                        style={{
                            color: '#00fcff',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            margin: '0 0 8px 0',
                        }}
                    >
                        Used: {bagInfo.usedSlots} / {bagInfo.totalSlots} slots
                    </p>
                    <p
                        style={{
                            color: '#00fcff',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            margin: '0 0 20px 0',
                        }}
                    >
                        Free: {bagInfo.freeSlots} slots — Needed: {bagInfo.needed} slots
                    </p>
                    <p
                        style={{
                            color: '#ffcc00',
                            fontSize: '13px',
                            margin: '0 0 24px 0',
                        }}
                    >
                        Please log into the game and clean your Item Mall bag (Bag 14), then click Re-check below.
                    </p>
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                        <button
                            onClick={handleRecheck}
                            disabled={isCheckingBag}
                            style={{
                                padding: '10px 28px',
                                background: isCheckingBag
                                    ? '#555'
                                    : 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
                                color: '#00fcff',
                                border: '1px solid #00fcff',
                                borderRadius: '6px',
                                cursor: isCheckingBag ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            {isCheckingBag ? 'Checking...' : '🔄 Re-check'}
                        </button>
                        <button
                            onClick={() => {
                                setShowBagModal(false);
                                setBagInfo(null);
                            }}
                            style={{
                                padding: '10px 28px',
                                background: 'transparent',
                                color: '#888',
                                border: '1px solid #555',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '14px',
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-content">
            <BagFullModal />
            <div className="page-top">Check out</div>
            <div className="text-text">
                <div className="cart-user">
                    <UsernameWallet username={user.username} coin={user.coin} />
                </div>

                {selectedField === 'products' ? (
                    <div className="check_out_character">
                        <span>Character name</span>
                        <form>
                            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
                            <select
                                id="server"
                                onChange={(event) => setSelectedOption(event.target.value)}
                                value={selectedOption}
                            >
                                <option value="">Select Character name</option>
                                {characterNames.length > 0 ? (
                                    characterNames.map((item) => (
                                        <option value={item.Name}>{item.Name}</option>
                                    ))
                                ) : (
                                    <></>
                                )}
                            </select>
                        </form>
                    </div>
                ) : (
                    <></>
                )}
                <div className="cart-Block-bottom">
                    <div className="cart-Block-bottom-title">CART TOTALS</div>
                    <div className="cart-Block-bottom-bt-top flex-s-c total-section">
                        <div className="cart-subtotal">PRODUCT</div>
                        <div className="cart-total-img">
                            {selectedField === 'packages' ? <img src={PriceIcon} alt="" /> : <></>}
                            TOTAL
                        </div>
                    </div>
                    {CartProductsItems()}
                    <div className="cart-Block-bottom-bt flex-s-c">
                        <div className="cart-subtotal">Subtotal</div>
                        <div className="cart-total">
                            {selectedField === 'packages'
                                ? `$${Number(subtotal).toFixed(2)}`
                                : `${subtotal}`}
                        </div>
                    </div>
                    <div className="cart-Block-bottom-bt flex-s-c">
                        <div className="cart-subtotal">Total</div>
                        <div className="cart-total">
                            {selectedField === 'packages'
                                ? `$${Number(total).toFixed(2)}`
                                : `${total}`}
                        </div>
                    </div>

                    {cart[selectedField].length <= 0 ? (
                        <>
                            <p className="agree">
                                {' '}
                                Your cart is empty. Please add items from the Item Mall.
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="agree">
                                {' '}
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => {
                                        setIsChecked(!isChecked);
                                    }}
                                />{' '}
                                I have read and agree for the Terms and conditions{' '}
                            </p>
                            <div className="cart-link-centr-total">
                                {selectedField === 'products' ? (
                                    <>
                                        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                                        <span
                                            href="/"
                                            className="button_cart a"
                                            onClick={onCheckout}
                                        >
                                            {isCheckingBag ? 'Checking bag...' : 'Place Order'}
                                        </span>
                                    </>
                                ) : (
                                    <PayPalButton setIsBusy={setIsBusy} total={total} />
                                )}
                            </div>
                        </>
                    )}
                    {ErrorMessage}
                </div>
            </div>
        </div>
    );
}
